import { IdentifiableItemReference } from '@cinemark/content-api-client';
import type { SerializedRelationshipNode } from '@payloadcms/richtext-lexical';
import { MovieConverterHandlerComponent } from './relationship-handlers/movie-handler';

type RichTextRelationshipConverterComponentProps = {
  node: SerializedRelationshipNode | undefined;
};

export const RichTextRelationshipConverterComponent = ({ node }: RichTextRelationshipConverterComponentProps): React.JSX.Element | null => {
  if (!node) return null;

  switch (node.relationTo) {
    case 'movies':
      return <MovieConverterHandlerComponent value={node.value as IdentifiableItemReference} />;
    default:
      return null;
  }
};
